import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import CompanyLookup from "../../Partials/Lookup/CompanyLookup";
import Time from "../../../Time/Time";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import { Attachment } from "../../Partials/Attachment/Attachment";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { Timeline } from "../../Partials/Timeline/Timeline";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import PersonUpdateWillMount from "../../../Middleware/Middlewares/PersonUpdateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import Select from "../../Partials/Material/Select";
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { ContractListing } from "../../Partials/Listing/ContractListing";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import EntityLaunchpanel from "../../Partials/Launchpanel/EntityLaunchpanel";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import PersonCard from "../../Partials/Person/PersonCard";

class PersonUpdate extends Component {
  public state = {
    person: null,
    selectedCompany: null,
    avatar: null,
    id: null,
    firstName: null,
    lastName: null,
    email: null,
    role: null,
    phone1: null,
    phone2: null,
    profession: null,
    mainBankAccountId: null,
    mainBankAccountName: null,
    personAddress: {
      formattedAddress: ""
    },
    dateOfBirth: null,
    identityNumber: null,
    identityType: 255,
    amazonFolderName: null,
    openLeavePrompt: false,
    note: "",
    hasModifiedData: false,
    nextPath: "",
    ibanUsedForEntity: null,
    isSaving: false,
    events: [],
    eventsForContracts: [],
    tasks: [],
    fetchingEvents: true,
    fetchingTasks: true,
    genderTypeId: 3,
    languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2,
    
    attachments: [],
    documentAddress: {
      formattedAddress: "",
    },
    removed: false,
    сreateFromCoach: false,
    propertyCreateDataToBeSaved: {},
    anchorPersonEl: null,
    isDeletePromptOpen: false,
    beta: false,
    placeOfBirthAddress: {
      formattedAddress: "",
    },
    companyRole: "",
    additionalFields: [],
    lastSelectedIndex: null,
    newCompanyName: "",
    isCreateCompanyPopupOpen: false
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CONTACT_PERSON_UPDATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    PersonUpdateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);

    this.selectCompany = this.selectCompany.bind(this);
    this.clearCompany = this.clearCompany.bind(this);
    this.save = this.save.bind(this);
  }

  public initializePage = (person: PersonInterface) => {
    if (!person) {
      return this.redirectBack();
    }

    if (person?.documentAddress?.formattedAddress){
      this.setState({
        documentAddress: person.documentAddress
      })
    }

    if(this.props?.location?.query?.сreateFromCoach){
      this.setState({
        сreateFromCoach: true,
        person: person
      })
    }

    this.props.dispatch({
      type: Constants.PAGE_CONTACT_PERSON_UPDATE_CLEAR
    });

    const selectedCompany = person.companies[0];
    const companyRole = selectedCompany?.contactsForCompanies?.role;
    const additionalFields = [];
    if (person?.companies?.length > 1) {
      person?.companies?.forEach((company, index) => {
        if (index > 0) {
          additionalFields.push({
            selectedCompany: company,
            role: company?.contactsForCompanies?.role
          })
        }
      })
    }

    this.fetchEntityEvents(person.id);
    this.fetchPersonContractsEvents(person);

    const usingBeta = this.props && this.props.app && this.props.app.settings && this.props.app.settings.user && this.props.app.settings.user.beta;
    
    this.setState({
      person: person,
      id: person.id,
      selectedCompany: selectedCompany,
      amazonFolderName: person.amazonFolderName,
      note: person.note,
      firstName: person.firstName,
      lastName: person.lastName,
      email: person.email,
      role: person.role ? String(person.role.getRoleId()) : "",
      phone1: person.phone1,
      phone2: person.phone2,
      profession: person.profession,
      mainBankAccountId: person.mainBankAccountId,
      mainBankAccountName: person.mainBankAccountName,
      personAddress: person.address,
      attachments: person.attachments,
      dateOfBirth: person.dateOfBirth,
      placeOfBirthAddress: person.placeOfBirthAddress,
      identityNumber: person.identityNumber,
      identityType: person.identityType,
      genderTypeId: person.genderTypeId,
      languageTypeId: person.languageTypeId,
      removed: person.removed,
      beta: usingBeta,
      companyRole: companyRole,
      additionalFields: [...additionalFields],
    });

    if (Object.keys(this.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdCompany = this.props.app.savedDataBeforeRedirecting.createdCompany &&
        this.props.app.savedDataBeforeRedirecting.createdCompany;

      if (typeof createdCompany !== "undefined") {
        this.setState({
          selectedCompany: createdCompany
        })
      }

      if(this.props?.location?.query?.сreateFromCoach){
        this.setState({
          propertyCreateDataToBeSaved: this.props.app.savedDataBeforeRedirecting.propertyCreateDataToBeSaved
        })
      }

      this.setState({...this.props.app.savedDataBeforeRedirecting.personUpdateDataToBeSaved}, () => {
        this.props.dispatch({
          type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
        });
      });
    }
  }

  public componentWillReceiveProps(nextProps) {
    const prevId = parseInt(this.props.params.id, 10);
    const id = parseInt(nextProps.params.id, 10);
    const person = nextProps.app.persons.filter((person: PersonInterface) => person.id === id)[0];

    if (nextProps?.location?.query?.сreateFromCoach){
      this.setState({
        сreateFromCoach: true,
        person: person
      });
    }

    if (prevId !== id) {
      this.initializePage(person);
    } else {
      this.setState({
        attachments: !!person ? person.attachments : []
      });
    }
  }

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        contactId: entityId
      },
      onSuccess: data => {
        const contactEvents: EventInterface[] = data.events
          .filter((event: EventInterface) => !event.removed);
        this.setState({
          events: [...contactEvents],
          fetchingEvents: false
        });
      }
    });
  }

  public fetchPersonContractsEvents = (person: PersonInterface) => {
    const contractIds = person.contracts.filter(contract => contract.removed === false).map(contract => contract && contract.id);

    if(contractIds.length === 0) {
      return;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        contractIds: contractIds
      },
      onSuccess: data => {
        const eventsForContracts = [...data.events]
          .filter((event: EventInterface) => !!event &&
                                              event.removed === false &&
                                              event.hidden === false &&
                                              (event.eventTypeId === 16 ||
                                                event.eventTypeId === 21 ||
                                                event.eventTypeId === 33));

        this.setState({
          eventsForContracts: eventsForContracts
        });
      }
    });
  }

  public selectCompany(company: CompanyInterface, isManuallySelected: boolean): void {
    this.setState({
      selectedCompany: company,
      avatar: company.avatar,
      hasModifiedData: isManuallySelected
    });
  }

  public clearCompany(): void {
    this.setState({
      selectedCompany: null,
      avatar: null,
      hasModifiedData: true
    });
  }

  public deleteContract(contract: ContractInterface): any {
    this.props.dispatch({
      type: Constants.GLOBAL_CONTRACT_DELETE_START,
      payload: {
        contract: contract
      }
    });
  }

  public save() {
    const iban = this.state.mainBankAccountId;

    if (iban) {
      const company: CompanyInterface = this.props.app.companies.find((company: CompanyInterface) => company.mainBankAccountId === this.state.mainBankAccountId);
      const person: PersonInterface = this.props.app.persons.find((person: PersonInterface) => person.mainBankAccountId === this.state.mainBankAccountId);

      if (!!person ) {
        this.setState({
          ibanUsedForEntity: person
        });
      }

      if (!!company ) {
        this.setState({
          ibanUsedForEntity: company
        });
      }
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_UPDATE_START,
        payload: {
          id: this.state.id,
          isFromDialog: false,
          person: {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            profession: this.state.profession,
            mainBankAccountId: this.state.mainBankAccountId,
            mainBankAccountName: this.state.mainBankAccountName,
            bankAccount: {
              accountId: this.state.mainBankAccountId,
              name: this.state.mainBankAccountName
            },
            email: this.state.email,
            phone1: this.state.phone1,
            phone2: this.state.phone2,
            contactRoleId: null,
            dateOfBirth: Time.formatOrNull(this.state.dateOfBirth),
            placeOfBirth: this.state.placeOfBirthAddress,
            identityNumber: this.state.identityNumber,
            identityType: this.state.identityType,
            // companyId: !this.state.selectedCompany ? null : this.state.selectedCompany.id,
            address: Object.keys(this.state.personAddress || {}).length > 0 ? { ...this.state.personAddress } : null,
            note: this.state.note,
            genderTypeId: this.state.genderTypeId,
            languageTypeId: this.state.languageTypeId,
            documentAddress: this.state.documentAddress,
            additionalFields: [...this.state.additionalFields],
            companyRole: this.state.companyRole,
            company: this.state.selectedCompany,
          },
          company: this.state.selectedCompany,
          previousCompanyId: this.state.person && this.state.person.companyId
        },
        onSuccess: () => {
          this.setState({isSaving: false}, () => {
            if (this.state.nextPath) {
              return this.redirect(this.state.nextPath);
            }

            return this.redirectBackModify();
          })
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public selectIdentityDocumentType = (event): void => {
    const type: number = event.target.value;

    this.setState({
      identityType: type,
      hasModifiedData: true
    });
  }

  public selectCountry = (event) => {
    this.setState({
      hasModifiedData: true,
      documentAddress: event,
    })
  }

  public clearCountry = () => {
    this.setState({
      hasModifiedData: true,
      documentAddress: {
        formattedAddress: "",
      }
    })
  }

  public selectPlaceOfBirth = (event) => {
    this.setState({
      hasModifiedData: true,
      placeOfBirthAddress: event,
    })
  }

  public clearPlaceOfBirth = () => {
    this.setState({
      hasModifiedData: true,
      placeOfBirthAddress: {
        formattedAddress: "",
      }
    })
  }

  public redirectBackModify = () => {
    if(this.state.сreateFromCoach) {
      const savedDataBeforeRedirecting = {...this.props.app.savedDataBeforeRedirecting};

      savedDataBeforeRedirecting.propertyCreateDataToBeSaved = this.state.propertyCreateDataToBeSaved;


      this.props.dispatch({
        type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
        payload: {
          savedDataBeforeRedirecting: {...savedDataBeforeRedirecting}
        }
      });
    }

    return this.redirectBack();
  }

   /* START Methods for 3-dot menu */

   protected openCompanyMenu = (event: any): void => {
    this.setState({
      anchorPersonEl: event.currentTarget
    });
  }

  protected closeCompanyMenu = (): void => {
    this.setState({
      anchorPersonEl: null
    });
  }

  protected openDeletePromptDialog = (entity: any): void => {
    this.setState({
      isDeletePromptOpen: true,
      entity: entity,
      anchorPersonEl: null
    });
  }

  public closeDeletePrompt = (): void => {
    this.setState({
      isDeletePromptOpen: false,
      anchorPersonEl: null
    });
  }

  public deletePerson = () => {
    this.closeDeletePrompt();
    return this.props.dispatch({
      type: Constants.GLOBAL_PERSON_DELETE_START,
      payload: {
        person: this.state.person
      },
      onSuccess: () => {
        this.redirectBack();
      }
    });
  }

  public addAdditionalFields = (): void => {
    const additionalFields = [...this.state.additionalFields];

    additionalFields.push({
      selectedCompany: null,
      role: ""
    });

    this.setState({additionalFields: [...additionalFields]});

    this.forceUpdate();
  }

  public renderAdditionalFields = (): any => {
    return this.state.additionalFields.map((data: any, index: number) => {
      if (!data) {
        return;
      }

      return (
        <div
          key={`additional-field-${index}`}
          style={{display: "flex", position: "relative", margin: "0px 0px -14px 0px"}}
        >
          <CompanyLookup
            {...this.props}
            filterOutEntities={this.state.additionalFields}
            isInlineBlock={true}
            width="100%"
            containerWidth="60%"
            onFocus={() => this.setState({lastSelectedIndex: index}) }
            autoSelectId={data && data.selectedCompany ? data && data.selectedCompany.id : null}
            floatingLabelText={this.trans("dropdown-searchforcompany-label") + this.trans("field/optional")}
            onSelect={this.selectAdditionalCompany}
            onClear={_company => {
              const additionalFields = [...this.state.additionalFields];
              additionalFields[index].selectedCompany = null;

              this.setState({
                additionalFields: [...additionalFields]
              }, () => {
                this.setModifiedData();
              });
            }}
            shouldOpenCoachModal={true}
            openCreateCompanyDialog={() => {
              this.props.dispatch({
                type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
              });

              this.setState({isCreateCompanyPopupOpen: true});
            }}
            disabled={this.state.removed}
          />

          <TextField
            autoComplete="off"
            className="form-element"
            style={{ width: "30%", boxSizing: "border-box", marginLeft: "45px" }}
            type="text"
            label={this.trans("role") + this.trans("field/optional")}
            value={this.state.additionalFields[index].role}
            onChange={e => {
              const additionalFields = [...this.state.additionalFields];
              additionalFields[index].role = (e.currentTarget as any).value;
              this.setState({additionalFields: [...additionalFields]});
              this.setModifiedData();
            }}
            variant="standard"
            error={false}
            disabled={this.state.removed}
          />

          <div
            className="icon icon-ic-close clear-button"
            style={{
              display: "inline-block",
              position: "absolute",
              top: "28px",
              right: "-20px",
              cursor: "pointer"
            }}
            onClick={this.removeAdditionalField.bind(this, index)}
          ></div>
        </div>
      );
    });
  }

  public removeAdditionalField = (index: number): void => {
    const additionalFields = [...this.state.additionalFields];
    additionalFields.splice(index, 1);

    this.setState({
      additionalFields: [...additionalFields],
      hasModifiedData: true
    });

    this.forceUpdate();
  }

  public selectAdditionalCompany = (company: CompanyInterface, isManuallySelected: boolean): void => {
    const additionalFields = [...this.state.additionalFields];

    if (isManuallySelected === true) {
      additionalFields[this.state.lastSelectedIndex].selectedCompany = company;
    }

    this.setState({
      hasModifiedData: isManuallySelected,
      additionalFields: [...additionalFields]
    });
  }

  public createCompany = () => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
      payload: {
        company: {
          name: this.state.newCompanyName,
          pageTemplate: "company"
        }
      },
      onSuccess: company => {
        if (typeof this.state.lastSelectedIndex === "number") {
          if (this.state.lastSelectedIndex === -1) {
            this.setState({
              selectedCompany: company
            })
          } else {
            const additionalFields = [...this.state.additionalFields];
            additionalFields[this.state.lastSelectedIndex]["selectedCompany"] = company;

            this.setState({
              additionalFields: additionalFields
            })
          }
        }

        this.setState({
          isCreateCompanyPopupOpen: false,
          newCompanyName: ""
        })
      },
      onError: () => {
      }
    });
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBackModify}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.state.person && this.state.person.roleDisplayName()} {this.state.person && this.state.person.firstName} {this.state.person && this.state.person.lastName}</h1>
              <div className="button-container" style={{minWidth: "initial"}}>
                {
                  this.state.hasModifiedData && (
                    <Button
                      color="primary"
                      onClick={this.redirectBackModify}
                      style={{marginRight: "20px"}}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                  )
                }
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.state.hasModifiedData ? this.save : this.redirectBackModify}
                  disabled={this.state.isSaving}
                >
                  {this.state.hasModifiedData ? this.trans("button-save") : this.trans("label-done")}
                </Button>
              </div>
            </div>
          </div>
          <div>
            <div className="box component-person-update">
              <div className="component-wrapper no-margin-top no-shadow">
                <div>
                  <div className="component" style={{boxShadow: "0 3px 6px 0 rgb(0 0 0 / 10%)"}}>

                    <PersonCard 
                      {...this.props}
                      key={`personcard-${this.state.person?.id}`}  
                      person={this.state.person} 
                      mainCardPresentation={true}
                      openedByDefault={this.props?.component?.openByDefault}
                      editableFields={
                        <div className="no-margins has-margin-bottom">
                          <Card className="card">
                            <div style={{maxWidth: "420px"}}>
                              <form>
                                <TextField
                                  autoComplete="off"
                                  // id="firstName"
                                  // name="firstName"
                                  className="form-element full-size scroll-to-firstName"
                                  type="text"
                                  label={this.trans("label-first-name")}
                                  value={this.state.firstName}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
                                  autoFocus={true}
                                  variant="standard"
                                  disabled={this.state.removed}
                                  error={!!this.getErrorFor("firstName")}
                                  helperText={this.getErrorFor("firstName")}
                                />

                                <TextField
                                  autoComplete="off"
                                  // id="lastName"
                                  // name="lastName"
                                  className="form-element full-size scroll-to-lastName"
                                  type="text"
                                  label={this.trans("label-last-name") + this.trans("field/optional")}
                                  value={this.state.lastName}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
                                  variant="standard"
                                  disabled={this.state.removed}
                                  error={!!this.getErrorFor("lastName")}
                                  helperText={this.getErrorFor("lastName")}
                                />

                                <div style={{display: "flex", margin: "-14px 0"}}>
                                  <CompanyLookup
                                    {...this.props}
                                    className="scroll-to-companyId"
                                    isInlineBlock={true}
                                    width="100%"
                                    containerWidth="60%"
                                    floatingLabelText={this.trans("dropdown-searchforcompany-label") + this.trans("field/optional")}
                                    searchText={this.state.selectedCompany && this.state.selectedCompany.displayName}
                                    autoSelectId={this.state.selectedCompany && this.state.selectedCompany.id}
                                    onFocus={() => this.setState({lastSelectedIndex: -1}) }
                                    onClear={this.clearCompany}
                                    onSelect={this.selectCompany}
                                    saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "personCreate")}
                                    shouldOpenCoachModal={true}
                                    openCreateCompanyDialog={() => {
                                      this.props.dispatch({
                                        type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
                                      });

                                      this.setState({isCreateCompanyPopupOpen: true});
                                    }}
                                    disabled={this.state.removed}
                                  />

                                  <TextField
                                    style={{ width: "30%", boxSizing: "border-box", marginLeft: "45px" }}
                                    autoComplete="off"
                                    // id="profession"
                                    // name="profession"
                                    className="form-element"
                                    type="text"
                                    label={this.trans("role") + this.trans("field/optional")}
                                    value={this.state.companyRole}
                                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyRole")}
                                    variant="standard"
                                    error={!!this.getErrorFor("role")}
                                    disabled={this.state.removed}
                                  />
                                </div>

                                <div className="hint-styles-wrapper">
                                  <span className="hint-styles">{this.trans("page/personcreateupdate-company-info")}</span>
                                </div>

                                {this.renderAdditionalFields()}

                                <Button
                                  color="primary"
                                  style={{
                                    width: "60%",
                                    boxSizing: "border-box",
                                    border: "1px solid rgba(0,0,0,.1)",
                                    display: "inline-block",
                                    margin: "10px 0px 0px 0px"
                                  }}
                                  className="plus-button"
                                  onClick={this.addAdditionalFields}
                                  disabled={this.state.removed}
                                >
                                  {this.trans("button-new-company")}
                                </Button>

                                <TextField
                                  autoComplete="off"
                                  className="form-element full-size scroll-to-email"
                                  label={this.trans("label-email") + this.trans("field/optional")}
                                  value={this.state.email}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
                                  variant="standard"
                                  disabled={this.state.removed}
                                  error={!!this.getErrorFor("email")}
                                  helperText={this.getErrorFor("email")}
                                />

                                <div style={{margin: "-14px 0"}}>
                                  <TextField
                                    autoComplete="off"
                                    // id="phone1"
                                    //name="phone1"
                                    className="form-element half-size scroll-to-phone1 textfield-width-half"
                                    type="text"
                                    label={this.trans("label-mob-number") + this.trans("field/optional")}
                                    value={this.state.phone1}
                                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
                                    variant="standard"
                                    disabled={this.state.removed}
                                    error={!!this.getErrorFor("phone1")}
                                    helperText={this.getErrorFor("phone1")}
                                  />

                                  <TextField
                                    autoComplete="off"
                                    // id="phone2"
                                    // name="phone2"
                                    className="form-element half-size scroll-to-phone2 textfield-width-half"
                                    type="text"
                                    label={this.trans("other-phone") + this.trans("field/optional")}
                                    value={this.state.phone2}
                                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone2")}
                                    variant="standard"
                                    disabled={this.state.removed}
                                    error={!!this.getErrorFor("phone2")}
                                    helperText={this.getErrorFor("phone2")}
                                  />
                                </div>

                                <Select
                                  className="form-element full-size form-input scroll-to-genderTypeId correct-label-position"
                                  variant="standard"
                                  error={this.getErrorFor("genderTypeId")}
                                  value={this.state.genderTypeId}
                                  onChange={this.sync.bind(this, this.syncronizers.GENDER_TYPE)}
                                  htmlFor="genderType"
                                  label={this.trans("gender-type") + this.trans("field/optional")}
                                  name="genderType" 
                                  id="genderType"
                                  disabled={this.state.removed}
                                >
                                  {this.getGenderTypeSelectboxes()}
                                </Select>

                                <Select
                                  className="form-element full-size form-input scroll-to-languageType correct-label-position"
                                  variant="standard"
                                  error={this.getErrorFor("languageTypeId")}
                                  value={this.state.languageTypeId}
                                  onChange={this.sync.bind(this, this.syncronizers.LANGUAGE_TYPE)}
                                  htmlFor="languageType"
                                  label={this.trans("language-type") + this.trans("field/optional")}
                                  name="languageType" 
                                  id="languageType"
                                  disabled={this.state.removed}
                                >
                                  {this.getLanguageTypeSelectboxes()}
                                </Select>

                                <DatePickerComponent
                                  {...this.props}
                                  // id="dateOfBirth"
                                  // name="dateOfBirth"
                                  className="scroll-to-dateOfBirth"
                                  label={this.trans("date-of-birth") + this.trans("field/optional")}
                                  initialDate={this.state.dateOfBirth}
                                  onChange={date => this.setState({ dateOfBirth: date, hasModifiedData: true })}
                                  clearButton={true}
                                  error={this.getErrorFor("dateOfBirth")}
                                  disabled={this.state.removed}
                                />

                                <AddressSelector
                                  {...this.props}
                                  // id="address"
                                  // name="address.googlePlaceId"
                                  className="scroll-to-documentAddress"
                                  labelText={this.trans("place-of-birth") + this.trans("field/optional")}
                                  searchText={this.state.placeOfBirthAddress.formattedAddress ? this.state.placeOfBirthAddress.formattedAddress : null}
                                  selectedAddress={this.state.placeOfBirthAddress}
                                  onSelect={this.selectPlaceOfBirth}
                                  onClear={this.clearPlaceOfBirth}
                                  //countryList={true}
                                  error={this.getErrorFor("placeOfBirth")}
                                  disabled={this.state.removed}
                                />

                                <Select
                                  className="form-element full-size form-input scroll-to-identityType correct-label-position"
                                  variant="standard"
                                  error={this.getErrorFor("identityType")}
                                  value={this.state.identityType}
                                  onChange={this.selectIdentityDocumentType}
                                  htmlFor="identityDocumentType"
                                  label={this.trans("identity-document-type") + this.trans("field/optional")}
                                  name="identityDocumentType" 
                                  id="identityDocumentType"
                                  disabled={this.state.removed}
                                >
                                  {this.getIdentityTypeSelectboxes()}
                                </Select>

                                <TextField
                                  autoComplete="off"
                                  // id="identityNumber"
                                  // name="identityNumber"
                                  className="form-element full-size scroll-to-identityNumber"
                                  type="text"
                                  label={this.trans("identity-document-number") + this.trans("field/optional")}
                                  value={this.state.identityNumber}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "identityNumber")}
                                  variant="standard"
                                  disabled={this.state.removed}
                                  error={!!this.getErrorFor("identityNumber")}
                                  helperText={this.getErrorFor("identityNumber")}
                                />

                                <AddressSelector
                                  {...this.props}
                                  // id="address"
                                  // name="address.googlePlaceId"
                                  className="scroll-to-documentAddress"
                                  labelText={this.trans("dropdown/documentcountry-label") + this.trans("field/optional")}
                                  searchText={this.state.documentAddress.formattedAddress ? this.state.documentAddress.formattedAddress : null}
                                  selectedAddress={this.state.documentAddress}
                                  onSelect={this.selectCountry}
                                  onClear={this.clearCountry}
                                  countryList={true}
                                  disabled={this.state.removed}
                                />

                                <AddressSelector
                                  {...this.props}
                                  // id="address"
                                  // name="address.googlePlaceId"
                                  className="scroll-to-address"
                                  searchText={this.state.personAddress.formattedAddress ? this.state.personAddress.formattedAddress : null}
                                  selectedAddress={this.state.personAddress}
                                  onSelect={this.sync.bind(this, this.syncronizers.VALUE, "personAddress")}
                                  onClear={this.sync.bind(this, this.syncronizers.VALUE, "personAddress", {})}
                                  disabled={this.state.removed}
                                />

                                <TextField
                                  autoComplete="off"
                                  // id="bankAccountId"
                                  // name="bankAccountId"
                                  className="form-element full-size scroll-to-mainBankAccountId"
                                  type="text"
                                  label={this.trans("label-bank-account-id") + this.trans("field/optional")}
                                  value={this.state.mainBankAccountId}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountId")}
                                  variant="standard"
                                  disabled={this.state.removed}
                                  error={!!this.getErrorFor("bankAccount.accountId")}
                                  helperText={this.getErrorFor("bankAccount.accountId")}
                                />

                                <TextField
                                  autoComplete="off"
                                  // id="mainBankAccountName"
                                  // name="mainBankAccountName"
                                  className="form-element full-size scroll-to-mainBankAccountName"
                                  type="text"
                                  label={this.trans("label-bank-account-name") + this.trans("field/optional")}
                                  value={this.state.mainBankAccountName}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountName")}
                                  variant="standard"
                                  error={!!this.getErrorFor("mainBankAccountName")}
                                  helperText={this.getErrorFor("mainBankAccountName")}
                                /> 

                                <TextField
                                  autoComplete="off"
                                  // id="note"
                                  // name="note"
                                  className="form-element full-size scroll-to-note"
                                  type="text"
                                  multiline={true}
                                  rowsMax={10}
                                  label={this.trans("note") + this.trans("field/optional")}
                                  value={this.state.note}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                                  variant="standard"
                                  disabled={this.state.removed}
                                  error={!!this.getErrorFor("note")}
                                  helperText={this.getErrorFor("note")}
                                />
                              </form>
                            </div>
                          </Card>
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>

              {this.state.person && this.state.person.contracts.filter(contract => contract.removed === false).length > 0 && (
                <div className="component-wrapper no-shadow">
                  <ContractListing
                    {...this.props}
                    contracts={this.state.person?.contracts || []}
                    personId={this.state.person && this.state.person.id}
                    dispatch={this.props.dispatch}
                    hideButton={this.state.person && this.state.person.removed}
                    eventsForContracts={this.state.eventsForContracts}
                  />
                </div>
              )}

              <div className="component-wrapper">
                <Attachment
                  {...this.props}
                  typeOfComponent="shared"
                  possibilityToSetAvatar={true}
                  title={this.trans("attachments-for-person")}
                  amazonFolderName={this.state.amazonFolderName}
                  relation="contactId"
                  entity={this.state.person}
                  attachments={this.state.attachments}
                  onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
                  onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
                  updateParentState={attachments => this.setState({attachments: attachments})}
                  disabled={this.state.removed}
                />
              </div>
            </div>

            {!this.state.removed && (
              <div className={"right-panel-wrapper"}>
                <EntityLaunchpanel
                  {...this.props}
                  entityTitle={this.trans("launchpanel-person-title")}
                  actionsList={
                    <List component="div" disablePadding>
                      {
                        this.state.person?.isTenant() && 
                        <ListItem
                          button
                          key={`send-tenant-portal-link-btn`}
                          onClick={() => this.redirect(`/app/email/send/tenant-login-portal-link/${this.state.person?.id || ""}`)}
                          style={{padding: "1px 16px"}}
                        >
                          <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-email"></div></ListItemIcon>
                          <ListItemText>{this.trans("launch-panel-send-tenant-portal-link")}</ListItemText>
                        </ListItem>
                      }
                      <ListItem
                        button
                        key="menuitem-remove"
                        onClick={this.openDeletePromptDialog}
                        style={{padding: "1px 16px"}}
                      >
                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-remove"></div></ListItemIcon>
                        <ListItemText>{this.trans("menuitem-delete-person")}</ListItemText>
                      </ListItem>
                    </List>
                  }
                />

                {
                  this.isBeta() && (
                    <Timeline
                      {...this.props}
                      relations={{ contactId: this.state.person && this.state.person.id }}
                      entityEvents={this.state.events}
                      fetchEntityEvents={this.fetchEntityEvents.bind(this, this.state.person && this.state.person.id)}
                      fetchingEvents={this.state.fetchingEvents}
                    />
                  )
                }    
              </div>
            )}
          </div>
        </div>

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isCreateCompanyPopupOpen}
          title={this.trans("title-new-company")}
          content={
            <div>
              <TextField
                autoComplete="off"
                className="form-element full-size scroll-to-name"
                type="text"
                label={this.trans("label-company-name")}
                value={this.state.newCompanyName}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "newCompanyName")}
                autoFocus={true}
                variant="standard"
                error={!!this.getErrorFor("name")}
              />
              {!!this.getErrorFor("name") && <div className="component-error-text">{this.getErrorFor("name")}</div>}
            </div>
          }
          positiveButtonLabel={this.trans("dialog-button/create")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={this.createCompany}
          onDiscard={() => this.setState({ isCreateCompanyPopupOpen: false, newCompanyName: "" }) }
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'contact-person-remove-dialog'}
          isOpen={this.state.isDeletePromptOpen}
          onCancel={this.closeDeletePrompt}
          onDelete={this.deletePerson}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    units: state.units,
    component: state.personUpdate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  PersonUpdate
);
